import { getCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { post } from "@insite/client-framework/Services/ApiService";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import { getDealers } from "@insite/client-framework/Services/DealerService";
import siteMessage from "@insite/client-framework/SiteMessage";
import setNavDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetNavDrawerIsOpen";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { DealerCollectionModel, DealerModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonProps } from "@insite/mobius/Button";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Hidden from "@insite/mobius/Hidden";
import Icon from "@insite/mobius/Icon/Icon";
import { MenuPresentationProps } from "@insite/mobius/Menu";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { setCookie } from "@insite/mobius/utilities/cookies";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import Menu from "@ucs/Components/LocationMenu";
import Canada from "@ucs/Icons/Canada";
import ChevronDown from "@ucs/Icons/ChevronDown";
import ChevronSmallUp from "@ucs/Icons/ChevronSmallUp";
import LocationIcon from "@ucs/Icons/Location";
import PhoneIcon from "@ucs/Icons/Phone";
import USA from "@ucs/Icons/USA";
import { IconProps } from "@ucs/MobiusOverrides/Icon/Icon";
import loadCurrentCountires from "@ucs/Store/Custom/LoadCurrentCountries";
import setCurrentCountries from "@ucs/Store/Custom/SetCurrentCountries";
import setGeoPermission from "@ucs/Store/Custom/setGeoPermission";
import {
    getCurrentCountriesState,
    getIsLoadingCurrentCountriesState,
    getIsLocalSelectedPLPState,
} from "@ucs/Store/CustomSelectors";
import { CustomState } from "@ucs/Store/Reducers";
import UCSColors from "@ucs/Utils/UCSColors";
import * as cssLinter from "css";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

const enum fields {
    phoneNumber = "phoneNumber",
    customCSS = "customCSS",
    showPricingToggle = "showPricingToggle",
    showInventoryToggle = "showInventoryToggle",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.phoneNumber]: string;
        [fields.customCSS]: string;
        [fields.showPricingToggle]: boolean;
        [fields.showInventoryToggle]: boolean;
    };
}

const mapStateToProps = (state: CustomState) => ({
    session: getSession(state),
    currentCountries: getCurrentCountriesState(state),
    isLoadingCurrentCountries: getIsLoadingCurrentCountriesState(state),
    isLocalSelectedPLPState: getIsLocalSelectedPLPState(state),
    displayPricingAndInventory: state.context.session?.displayPricingAndInventory || false,
});

const mapDispatchToProps = {
    setNavDrawerIsOpen,
    loadCurrentCountires,
    setCurrentCountries,
    setGeoPermission,
};

type Props = WidgetProps & OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export const enum Groups {
    Canada = "Upper Canada",
    USA = "Sierra",
    UCS = "UCS Forest Group",
}

const Navigation = styled.div`
    color: ${getColor("common.background")};
    font-size: 15px;
    background-color: ${getContrastColor("common.background")};
    text-transform: uppercase;
    display: flex;
    align-items: center;
    height: 40px;
    position: relative;
    ${({ theme }) =>
        breakpointMediaQueries(theme, [
            css`
                padding-left: 25px;
            `,
            css`
                padding-left: 25px;
            `,
            css`
                padding-left: 35px;
            `,
            css`
                padding-left: 35px;
            `,
            css`
                padding-left: 45px;
            `,
        ])};
`;

const NavItem = styled.span<InjectableCss>`
    display: inline-flex;
    flex: 0 0 auto;
    margin: 0px 15px;
    /* Bottom padding is smaller to compensate for Overpass font not being a middle aligned font */
    padding: 10px 0px 10px 5px;
    font-size: 0.75rem;
    font-weight: 400;
    letter-spacing: 0.5px;
    align-items: center;
    a,
    a > span:not([class^="IconWrapper"]) {
        color: white !important;
    }

    ${injectCss}
`;

const OffsetSpan = styled.span<InjectableCss>`
    /* margin-bottom: -4px; */
`;

const PhoneLink = styled.a`
    display: flex;
    align-items: center;
    height: 20px;
`;

export interface SecondaryNavigationCustomStyles {
    titleClickable: ClickablePresentationProps;
    chevronIcon: IconProps;
    menuItem: any;
    menuItemIcon: any;
    menuItemTypography: any;
    cascadingMenu: MenuPresentationProps;
    siteSelectorModal?: ModalPresentationProps;
    siteSelectorMessages?: TypographyProps;
    siteSelectorButtonSection?: TypographyProps;
    siteSelectorButton?: ButtonProps;
}

const styles: SecondaryNavigationCustomStyles = {
    titleClickable: {
        css: css``,
    },
    chevronIcon: {
        size: 20,
        color: "#fff",
        css: css`
            opacity: 0.5;
            margin-top: 10px;
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css`
                        margin-left: 60px;
                    `,
                    css`
                        margin-left: 60px;
                    `,
                    css`
                        margin-left: 60px;
                    `,
                    css`
                        margin-left: 60px;
                    `,
                ])};
        `,
    },
    menuItem: {
        css: css`
            display: flex;
            align-items: center;
            height: 50px;
            margin: 0 10px;
            height: 77px;
            padding: 3px 0px;

            &:hover {
                padding-bottom: 0px;
                border-bottom: 3px solid ${getColor("primary")};
            }
        `,
    },
    menuItemIcon: {
        css: css`
            margin: -3px 0 0 10px;
        `,
        size: 18,
        color: "secondary.contrast",
    },
    menuItemTypography: {
        color: UCSColors.gray03,
        size: "18px",
        weight: 500,
    },
    cascadingMenu: {},
    siteSelectorModal: {
        size: 540,
        cssOverrides: {
            modalContent: css`
                padding: 0 20px 64px;
                background-color: ${UCSColors.gray07};
            `,
            modalTitle: css`
                padding: 14px 10px;
                border-bottom: none;
                background-color: ${UCSColors.gray07};
            `,
            titleButton: css`
                width: 20px;
                height: 20px;
                min-height: 20px;
                padding: 0;
                position: relative;
                background-color: transparent !important;
                background: transparent !important;
                border: none;
                & span {
                    position: absolute !important;
                    top: 0 !important;
                    left: -1px;
                    width: 18px;
                    height: 18px;
                }
                & svg {
                    width: 18px;
                    height: 18px;
                }
                &:hover {
                    background-color: transparent !important;
                    background: transparent !important;
                    border: none;
                }
            `,
            modalContainer: css`
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            margin-top: 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            height: 100%;
                        `,
                        css`
                            margin-top: 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            height: 100%;
                        `,
                        css`
                            margin-top: 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            height: 100%;
                        `,
                    ]);
                }}
            `,
            modalBody: css`
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            height: auto;
                            width: 95vw;
                            min-height: 350px;
                            max-width: 380px;
                            box-shadow: ${theme?.shadows[3]};
                        `,
                        css`
                            height: auto;
                            max-height: calc(100% - 40px);
                            margin: 25px;
                            max-width: 540px;
                            box-shadow: ${theme?.shadows[3]};
                        `,
                        css`
                            height: auto;
                            max-height: calc(100% - 90px);
                            margin: 45px;
                            max-width: 540px;
                            box-shadow: ${theme?.shadows[3]};
                        `,
                    ]);
                }}
            `,
        },
    },
    siteSelectorMessages: {
        variant: "h4",
        color: UCSColors.gray00,
        css: css`
            margin-bottom: 5px;
        `,
    },
    siteSelectorButtonSection: {
        css: css`
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 10px;
            margin-top: 27px;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        grid-template-columns: 100%;
                    `,
                ]);
            }}
        `,
    },
    siteSelectorButton: {
        buttonType: "outline",
        typographyProps: {
            variant: "p",
            size: 18,
            color: "#000",
            transform: "none",
            css: css`
                margin: 0 0 0 10px;
                line-height: 20px;
            `,
        },
        css: css`
            background-color: #fff;
            padding: 10px;
            display: flex;
            align-items: center;
            text-align: left;
            & svg,
            span {
                width: 47px;
                height: 47px;
            }
        `,
    },
};
const defaultCustomCss = `.wrapper {
}

.navigation-mode-menu {
}

.currency-menu {
}

.language-menu {
}

.ship-to-address-menu {
}

.sign-in-link {
}`;

interface SecondaryNavigationState {
    isExpanded: boolean;
    customerLocation: string;
    selectedLocation: string;
    selectedLocationId: string;
    selectedPhoneNumber1: string;
    selectedPhoneNumber2: string;
    selectedFax: string;
    dealerData: Partial<DealerCollectionModel>;
    dealers: DealerModel[];
    // countries: CountryModel[] | undefined;
    geoTargetedLocation: DealerModel | undefined;
    closestLocation: string | undefined;
    closestLocationId: string | undefined;
    dealersPageLinks: PageLinkModel[];
    canadaLink: string;
    usaLink: string;
    siteRedirect: string;
    currentCountry: Groups;
    modalIsOpen: boolean;
    redirectUrl: string;
}

function getRedirectURL(parameter: any) {
    return post<any>("/api/v1/customApis/redirectUrl", parameter);
}

class SecondaryNavigation extends React.Component<Props, SecondaryNavigationState> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isExpanded: false,
            customerLocation: getCookie("SelectedLocation") || getCookie("DefaultCustomerLocation") || "Toronto, ON",
            selectedLocation: getCookie("SelectedLocation") || getCookie("geoTargetedLocation") || "",
            selectedLocationId: getCookie("SelectedLocationId") || getCookie("geoTargetedLocation") || "",
            selectedPhoneNumber1: getCookie("LocationPhoneNumber1") || "",
            selectedPhoneNumber2: getCookie("LocationPhoneNumber2") || "",
            selectedFax: getCookie("LocationFax") || "",
            dealerData: {},
            dealers: [],
            // countries: [],
            geoTargetedLocation: undefined,
            closestLocation: undefined,
            closestLocationId: undefined,
            dealersPageLinks: [],
            canadaLink: siteMessage("Site_Url_CA") as string,
            usaLink: siteMessage("Site_Url_US") as string,
            siteRedirect: getCookie("Siteredirect") || "",
            currentCountry: Groups.Canada,
            modalIsOpen: false,
            redirectUrl: "",
        };
    }

    UNSAFE_componentWillMount(): void {
        const { currentCountries, isLoadingCurrentCountries, loadCurrentCountires } = this.props;
        if (currentCountries.length === 0 && !isLoadingCurrentCountries) {
            loadCurrentCountires({});
        }
    }

    // Logic to fix refreshing page will always only take the geotargetting location and not user selectors
    // We will have to do a check to see if the user has manually changed the selector from the geotargeted selection
    // if so don't use the geotargeted location, use the selected location when the page reloads
    componentDidMount = async () => {
        if (this.props.currentCountries.length > 0) {
            await this.refreshComponentBasedOnCountries();
        }
    };

    componentDidUpdate = async (prevProps: Props) => {
        // Check if currentCountries has been updated
        if (this.props.currentCountries !== prevProps.currentCountries && this.props.currentCountries.length > 0) {
            await this.refreshComponentBasedOnCountries();
        }
    };

    refreshComponentBasedOnCountries = async () => {
        // if (this.props.session.isAuthenticated) {
        //     // eslint-disable-next-line no-console
        //     // console.log("TODO: get customer location"); // TODO
        // } else {

        let lat = 0;
        let long = 0;
        let isGeoPermissionDenied = false;
        const location = window.navigator && window.navigator.geolocation;
        if (location) {
            try {
                const position: any = await this.getAddress();
                if (position) {
                    lat = position.coords.latitude;
                    long = position.coords.longitude;
                }
                this.props.setGeoPermission({ isGeoPermissionDenied: "No" });
            } catch (error) {
                if ("PERMISSION_DENIED" in error && error.PERMISSION_DENIED === 1) {
                    isGeoPermissionDenied = true;
                } else {
                    isGeoPermissionDenied = false;
                }
                this.props.setGeoPermission({ isGeoPermissionDenied: "Yes" });
                console.warn(`Geolocation - Permission Denied: ${isGeoPermissionDenied}`);
            }
        }

        const dealerData = await getDealers({
            name: "",
            longitude: long,
            latitude: lat,
            radius: 99999,
            additionalQueryStringParameters: { useDefaultLocation: lat === 0 && long === 0 },
        });
        const { currentCountries } = this.props;
        const redirectURL = await getRedirectURL({ currentUrl: window.location.href });
        this.setState({ redirectUrl: redirectURL });
        const currentCountry = currentCountries[0]?.abbreviation === "CA" ? Groups.Canada : Groups.USA;
        this.setState({ currentCountry });

        if (dealerData && dealerData.dealers) {
            let selectedDealer = dealerData.dealers[0];
            dealerData?.dealers?.forEach(dealer => {
                if (dealer.distance < selectedDealer.distance) {
                    selectedDealer = dealer;
                }
            });
            const geoTargeted = selectedDealer;
            this.setState(
                {
                    dealerData,
                    // countries: currentCountries,
                    dealers: dealerData.dealers || [],
                    geoTargetedLocation: geoTargeted,
                },
                () => this.loadLocationAndCookies(dealerData, geoTargeted, isGeoPermissionDenied),
            );
        }
    };

    loadLocationAndCookies = (
        dealerData: DealerCollectionModel,
        geoTargeted: DealerModel,
        isGeoPermissionDenied: boolean,
    ) => {
        if (dealerData && dealerData.dealers) {
            if (geoTargeted) {
                setCookie("geoTargetedLocation", geoTargeted.id, { path: "/" });
            }
        }
        const redirect = getCookie("SiteRedirect");
        if (!redirect && dealerData.properties.originCountry) {
            const originCountry =
                dealerData.properties.originCountry.toUpperCase() === "CA"
                    ? Groups.Canada
                    : dealerData.properties.originCountry.toUpperCase() === "US"
                      ? Groups.USA
                      : undefined;
            if (originCountry && originCountry !== this.state.currentCountry) {
                if (!isGeoPermissionDenied) {
                    this.setState({ modalIsOpen: true });
                }
            }
        }
        const locationCoockie = getCookie("SelectedLocation") || getCookie("geoTargetedLocation") || "No location set";
        const locationIdCoockie = getCookie("SelectedLocationId") || "";
        this.setState({
            selectedLocation: locationCoockie,
            selectedLocationId: locationIdCoockie,
            selectedPhoneNumber1: getCookie("LocationPhoneNumber1") || "",
            selectedPhoneNumber2: getCookie("LocationPhoneNumber2") || "",
            selectedFax: getCookie("LocationFax") || "",
        });
        if (
            this.state.geoTargetedLocation &&
            (!this.state.selectedLocationId.length || this.state.selectedLocationId.length === 0)
        ) {
            this.setState(
                {
                    closestLocation: `${this.state.geoTargetedLocation?.city}, ${this.state.geoTargetedLocation?.state}`,
                    closestLocationId: this.state.geoTargetedLocation?.id,
                },
                this.updatePageDataCookie,
            );
        }
        this.setState({
            dealersPageLinks: this.createPageLinksFromDealers(this.state.dealers) || [],
        });
    };

    updatePageDataCookie() {
        if (this.state.closestLocationId) {
            const updatedLocationData = this.getUpdatedPageData(this.state.closestLocationId);
            this.updateCookies(
                updatedLocationData!.phoneNumber1 || "",
                updatedLocationData!.phoneNumber2 || "",
                updatedLocationData!.fax || "",
                updatedLocationData!.location || "",
                updatedLocationData!.contactUsInfo || "",
                updatedLocationData!.salesEmail || "",
                updatedLocationData!.locationId || "",
                updatedLocationData!.openingHours || "",
                updatedLocationData!.locationBasedAttributeValue || "",
            );

            this.setSelectedLocation(
                updatedLocationData?.locationId || "",
                updatedLocationData?.location || "",
                updatedLocationData?.phoneNumber1 || "",
                updatedLocationData?.phoneNumber2 || "",
                updatedLocationData?.fax || "",
            );
        }
    }
    async getAddress() {
        const position = await this.getCoordinates();
        return position;
    }

    getCoordinates = () => {
        return new Promise(function (resolve, reject) {
            navigator.geolocation.getCurrentPosition(resolve, reject);
        });
    };

    componentWillUnmount = () => {
        this.setState({ dealerData: {}, dealers: [] });
    };

    toggleMenu = () => {
        this.closeDrawer();
        this.setState({ isExpanded: !this.state.isExpanded });
    };

    closeMenu = () => {
        setTimeout(() => {
            this.setState({ isExpanded: false });
        }, 400);
    };

    modalCloseHandler = () => {
        setCookie("SiteRedirect", "No");
        this.setState({ modalIsOpen: false });
    };

    siteChange = () => {
        window.location.href = `${this.state.redirectUrl}?disableSSR=true`;
        this.setState({ modalIsOpen: false });
    };

    siteStay = () => {
        setCookie("SiteRedirect", "No", { expires: 30 });
        this.setState({ modalIsOpen: false });
    };

    updateCookies = (
        locationPhoneNumber1?: string,
        locationPhoneNumber2?: string,
        locationFax?: string,
        selectedLocation?: string,
        contactUsInfo?: string,
        salesEmail?: string,
        selectedLocationId?: string,
        openingHours?: string,
        locationBasedAttributeValue?: string,
    ) => {
        setCookie("LocationPhoneNumber1", locationPhoneNumber1 || "", { path: "/" });
        setCookie("LocationPhoneNumber2", locationPhoneNumber2 || "", { path: "/" });
        setCookie("LocationFax", locationFax || "", { path: "/" });
        setCookie("SelectedLocation", selectedLocation || "", { path: "/" });
        setCookie("SelectedLocationId", selectedLocationId || "", { path: "/" });
        setCookie("ContactUsInfoCookie", contactUsInfo || "", { path: "/" });
        setCookie("SalesEmailCookie", salesEmail || "", { path: "/" });
        setCookie("LocationOpeningHours", openingHours || "", { path: "/" });
        setCookie("LocationBasedAttributeValue", locationBasedAttributeValue || "", { path: "/" });
        const filteredLocationString = this.getDealerDataForLocationCookie(this.state.dealers);
        setCookie("LocationDropdownData", JSON.stringify(filteredLocationString || ""), { path: "/" });
    };

    getUpdatedPageData = (
        locationId: string,
    ):
        | {
              phoneNumber1: string;
              phoneNumber2: string;
              fax: string;
              location: string;
              contactUsInfo: string;
              salesEmail: string;
              locationId: string;
              openingHours: string;
              locationBasedAttributeValue: string;
          }
        | undefined => {
        const getLocationData = this.state.dealers.find(dealer => dealer.id === locationId);
        this.setState({
            dealersPageLinks: this.createPageLinksFromDealers(this.state.dealers) || [],
        });

        if (getLocationData) {
            const country = this.props.currentCountries!.find(
                country => country.id === getLocationData.countryId,
            )?.name;
            const salesEmail = getLocationData.properties["insideSalesEmail"] || "";
            const phoneNumber1 = getLocationData.phone || "Not set";
            const phoneNumber2 = getLocationData.properties["phone2"] || "";
            const fax = getLocationData.properties["fax2"] || "";
            const location = `${getLocationData.name}, ${getLocationData.state}`;
            const locationId = getLocationData.id || "no id";
            const contactUsInfo = `${getLocationData.address1} ${getLocationData.city}, ${getLocationData.state} ${country} ${getLocationData.postalCode}`;
            const openingHours = getLocationData.properties["openingHours"] || "";
            const locationBasedAttributeValue = getLocationData.properties["locationBasedAttributeValue"] || "";
            return {
                phoneNumber1,
                phoneNumber2,
                fax,
                location,
                contactUsInfo,
                salesEmail,
                locationId,
                openingHours,
                locationBasedAttributeValue,
            };
        }
        return undefined;
    };

    setSelectedLocation = (
        locationId: string,
        location: string,
        phoneNumber1: string,
        phoneNumber2: string,
        fax: string,
    ) => {
        this.setState({
            selectedLocation: location,
            selectedLocationId: locationId,
            selectedPhoneNumber1: phoneNumber1,
            selectedPhoneNumber2: phoneNumber2,
            selectedFax: fax,
        });
    };

    // Is called on the locationMenu component when clicking a city location menu item.
    updateSelectedLocation = (selectedLocation: string) => {
        const updatedLocationData = this.getUpdatedPageData(selectedLocation);
        this.updateCookies(
            updatedLocationData!.phoneNumber1 || "",
            updatedLocationData!.phoneNumber2 || "",
            updatedLocationData!.fax || "",
            updatedLocationData!.location || "",
            updatedLocationData!.contactUsInfo || "",
            updatedLocationData!.salesEmail || "",
            updatedLocationData!.locationId || "",
            updatedLocationData!.openingHours || "",
            updatedLocationData!.locationBasedAttributeValue || "",
        );
        const url = window.location.origin + window.location.pathname;
        if (window.location.search.includes("attributeValueIds") && this.props?.isLocalSelectedPLPState === true) {
            window.location.href = `${url}?attributeValueIds=${updatedLocationData?.locationBasedAttributeValue}`;
        } else {
            window.location.reload();
        }
    };

    createPageLinksFromDealers = (dealers: DealerModel[]): PageLinkModel[] => {
        let canadaLink = this.state.canadaLink;
        if (!this.state.canadaLink.includes("disable")) {
            canadaLink = `${this.state.canadaLink}?disableSSR=true`;
        }

        let usaLink = this.state.usaLink;
        if (!this.state.usaLink.includes("disable")) {
            usaLink = `${this.state.usaLink}?disableSSR=true`;
        }

        // TODO: Ask where other website urls are stored and if we can access them from storefront
        const menuGroups = [
            {
                name: Groups.Canada,
                identifier: "CA",
                url: this.state.currentCountry === Groups.Canada ? "" : canadaLink,
            },
            {
                name: Groups.USA,
                identifier: "US",
                url: this.state.currentCountry === Groups.USA ? "" : usaLink,
            },
        ];

        const pageLinkModelCloneList: PageLinkModel[] & never[] = Object.assign([], []);

        // dealers.sort((a, b) => {
        //     const compareA = a.name.toUpperCase();
        //     const compareB = b.name.toUpperCase();
        //     return compareA.localeCompare(compareB);
        // });

        menuGroups.forEach(group => {
            const pageLinkCloneGroup: PageLinkModel = {
                title: `${group.name}`,
                url: group.url,
                type: "",
                id: "",
                parentId: "",
                excludeFromNavigation: false,
                children: [],
            };
            pageLinkModelCloneList.push(pageLinkCloneGroup);
            dealers.forEach(dealer => {
                if (
                    this.props.currentCountries!.find(
                        country =>
                            country.id === dealer.countryId &&
                            country.abbreviation?.toLowerCase() === group.identifier.toLowerCase(),
                    )
                ) {
                    // Here we make this type any to easily extend it.
                    const pageLinkCloneDealer: any = {
                        title: `${dealer.name}, ${dealer.state}`,
                        url: "",
                        type: "",
                        id: dealer.id,
                        parentId: "",
                        excludeFromNavigation: false,
                        children: [],
                        updateSelectedLocation: this.updateSelectedLocation, // Add callback
                    };
                    pageLinkModelCloneList.push(pageLinkCloneDealer);
                }
            });
        });
        this.setState({ dealers: dealers || [] });
        const filteredLocationString = this.getDealerDataForLocationCookie(dealers);
        setCookie("LocationDropdownData", JSON.stringify(filteredLocationString || ""), { path: "/" });
        return pageLinkModelCloneList;
    };

    getDealerDataForLocationCookie = (dealers: DealerModel[]) => {
        const simplifiedDealerDataForLocationCookie = dealers.map(dealer => ({
            id: dealer.id,
            name: dealer.name,
            city: dealer.city,
            state: dealer.state,
        }));

        return simplifiedDealerDataForLocationCookie;
    };

    closeDrawer = () => {
        this.props.setNavDrawerIsOpen({ navDrawerIsOpen: false });
        setTimeout(() => this.props.setNavDrawerIsOpen({ navDrawerIsOpen: undefined }), 300);
    };

    render() {
        return (
            <>
                <Navigation>
                    <StyledWrapper
                        css={css`
                            align-self: flex-start;
                            flex: 1 0 auto;
                            justify-content: flex-start;
                            display: inline-flex;
                        `}
                    >
                        <NavItem style={{ marginLeft: "0px", marginRight: "5px" }} onClick={this.closeDrawer}>
                            <Zone zoneName="LeftLink" contentId={this.props.id}></Zone>
                        </NavItem>
                        <NavItem>
                            <PhoneLink
                                href={`tel:${
                                    this.state.selectedPhoneNumber1
                                        .replace(" ", "")
                                        .replace("\n", "")
                                        .replace("\t", "") || ""
                                }`}
                            >
                                <Icon style={{ marginRight: "5px" }} src={PhoneIcon} size={20} color="#639980" />
                                <Hidden below="sm">
                                    <OffsetSpan>{this.state.selectedPhoneNumber1 || ""}</OffsetSpan>
                                </Hidden>
                            </PhoneLink>
                        </NavItem>
                    </StyledWrapper>
                    <StyledWrapper
                        css={css`
                            align-self: flex-end;
                            flex: 1 0 auto;
                            justify-content: flex-end;
                            display: inline-flex;
                            height: 40px !important;
                        `}
                    >
                        <Hidden below="md" onClick={this.closeDrawer}>
                            <NavItem>
                                <Zone zoneName="RightLink" contentId={this.props.id}></Zone>
                            </NavItem>
                        </Hidden>
                        {this.props.session.isGuest || !this.props.session.isAuthenticated ? (
                            <Menu
                                descriptionId="locationMenu"
                                menuItems={this.state.dealersPageLinks}
                                maxDepth={1}
                                onMouseLeave={this.closeMenu}
                                onClick={this.toggleMenu}
                                isOpen={this.state.isExpanded}
                                currentCountry={this.state.currentCountry}
                                menuTrigger={
                                    <Clickable {...styles.titleClickable}>
                                        <StyledWrapper
                                            css={css`
                                                ${({ theme }) =>
                                                    breakpointMediaQueries(theme, [
                                                        css``,
                                                        css``,
                                                        css`
                                                            min-width: 180px !important;
                                                        `,
                                                        css`
                                                            min-width: 180px !important;
                                                        `,
                                                        css`
                                                            min-width: 180px !important;
                                                        `,
                                                    ])};
                                                background-color: ${getColor("primary")};
                                                margin-right: 0px;
                                                margin-left: 0px;
                                                padding-right: 10px;
                                                height: 40px !important;
                                                font-size: 12px;
                                                display: inline-flex;
                                                flex: 1 1 auto;
                                                align-self: flex-start;
                                                justify-content: flex-start;
                                                span:nth-last-child(2n) {
                                                    letter-spacing: 0.5px;
                                                    margin-top: 11px;
                                                }
                                            `}
                                            {...styles.cascadingMenu}
                                        >
                                            <Icon
                                                src={LocationIcon}
                                                size={20}
                                                color="#fff"
                                                style={{ opacity: 0.5, marginRight: "5px", marginTop: "10px" }}
                                            />
                                            {/* TODO: This will be loaded from session when a guest user selects a city, I will need to update the session */}
                                            <OffsetSpan>{this.state.selectedLocation}</OffsetSpan>
                                            {!this.state.isExpanded ? (
                                                <Icon {...styles.chevronIcon} src={ChevronDown} />
                                            ) : (
                                                <Icon {...styles.chevronIcon} src={ChevronSmallUp} />
                                            )}
                                        </StyledWrapper>
                                    </Clickable>
                                }
                                cssOverrides={{
                                    wrapper: css`
                                        flex: 0 1 auto;
                                        min-width: 0;
                                    `,
                                    menu: css`
                                        right: 1px !important;
                                        max-height: 80vh;
                                        overflow-y: auto;
                                        width: 250px;
                                    `,
                                }}
                            />
                        ) : (
                            <NavItem
                                css={css`
                                    background-color: ${getColor("primary")};
                                    margin-right: 0px;
                                    padding-left: 10px;
                                    padding-right: 10px;
                                    min-width: 180px;
                                `}
                            >
                                <Icon
                                    src={LocationIcon}
                                    size={20}
                                    color="#fff"
                                    style={{ opacity: 0.5, marginRight: "5px" }}
                                />
                                <OffsetSpan>{this.state.customerLocation}</OffsetSpan>
                            </NavItem>
                        )}
                    </StyledWrapper>
                </Navigation>
                <Modal
                    {...styles.siteSelectorModal}
                    headline=""
                    isOpen={this.state.modalIsOpen}
                    handleClose={this.modalCloseHandler}
                >
                    <Typography {...styles.siteSelectorMessages}>{siteMessage("SiteSelector_Current")}</Typography>
                    <Typography {...styles.siteSelectorMessages}>{siteMessage("SiteSelector_Switch")}</Typography>
                    <StyledWrapper {...styles.siteSelectorButtonSection}>
                        <Button
                            icon={{
                                src: this.state.currentCountry === Groups.Canada ? USA : Canada,
                                position: "left",
                            }}
                            {...styles.siteSelectorButton}
                            onClick={this.siteChange}
                        >
                            {siteMessage("SiteSelector_Proceed")}
                        </Button>
                        <Button
                            icon={{ src: this.state.currentCountry === Groups.Canada ? Canada : USA, position: "left" }}
                            {...styles.siteSelectorButton}
                            onClick={this.siteStay}
                        >
                            {siteMessage("SiteSelector_Stay")}
                        </Button>
                    </StyledWrapper>
                </Modal>
            </>
        );
    }
}

const secondaryNavigation: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SecondaryNavigation),
    definition: {
        group: "Header",
        allowedContexts: ["Header"],
        icon: "link-simple",
        fieldDefinitions: [
            {
                name: fields.phoneNumber,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
            {
                name: fields.showPricingToggle,
                displayName: "Show/Hide Pricing Toggle",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.showInventoryToggle,
                displayName: "Show/Hide Inventory Toggle",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default secondaryNavigation;
